export default class BlockTimeline {
	static init() {

		let blocks = document.querySelectorAll('.block-timeline');

		blocks.forEach( (block) => {

			let timeline = block.querySelector('.timeline');
			let years = timeline.querySelectorAll('.year');

			let swiperText = block.querySelector('.swiper-slider-content');

			const prev = block.querySelector(".prev");
			const next = block.querySelector(".next");
			let swiper = new Swiper(swiperText, {
				slidesPerView: "1",
				grabCursor: true,
				speed: 600,
				navigation: {
					prevEl: prev,
					nextEl: next
				},
				on: {
					slideChange: (el) => {
						years[el.activeIndex].click();
					}
				}
			});

			this.centerCurrent();

			years.forEach( (year, index) => {
				year.addEventListener('click', () => {
					document.querySelector('.timeline .year.current')?.classList.remove('current');
					year.classList.add('current');
					this.centerCurrent();
					swiper.slideTo(index);
				});
			});

		});

	}

	static centerCurrent() {
		const timeline = document.querySelector('.timeline');
		const years = Array.from(timeline.querySelectorAll('.year'));
		const current = timeline.querySelector('.year.current');
		if (!current) return;

		const index = years.indexOf(current);

		// Calcule la position de départ de la .timeline
		let offset = 0;
		for (let i = 0; i < index; i++) {
			offset -= 30; // +20 si tu as margin: 10px de chaque côté
		}

		timeline.style.transform = `translateX(${offset}px)`;
	}

}
